/**
 * @param {Object} chartData - The chartData object.
 * @param {string|null} [orderId] - Optional order ID; attempts to infer if possible.
 */
export default class Rule {
  constructor(currentChartData, futureChartData, orderActivityId = null) {
    this.currentChartData = currentChartData;
    this.futureChartData = futureChartData;

    try {
          this.orderActivityId = Rule.getSingleOrderId(currentChartData, orderActivityId);
        } catch {
      this.orderActivityId = undefined;
    }
  }

  fail() {
    return { passed: false, message: this.constructor.message };
  }

  pass() {
    return { passed: true };
  }

  run() {
    throw new Error("You must override the run() method.");
  }

  static getSingleOrderId(chartData, explicitOrderId = null) {
    const orderActivity = chartData?.orderActivity || {};
    const allOrderIds = Object.keys(orderActivity);

      if (explicitOrderId) {
        if (!orderActivity[explicitOrderId]) {
          throw new Error(`Order ID ${explicitOrderId} not found in chartData.`);
        }
        return explicitOrderId;
      }

      if (allOrderIds.length === 1) {
        return allOrderIds[0];
      }

      throw new Error("Order ID is required when multiple orders are present.");
    }
}